import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PropertyService } from '../service/property.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { UserType } from '../../../core/enum/UserType';


@Component({
  selector: 'app-create-property',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MultiSelectModule
  ],
  templateUrl: './create-property.component.html',
  styleUrls: ['./create-property.component.scss'],
})
export class CreatePropertyComponent {
  @Input() property: any | null = null;
  @Input() buttonLabel: any | null = null;
  @Output() closeDialog = new EventEmitter<void>();
  propertyForm: FormGroup;
  users: any[] = [];
  countries: any[] = [];
  amenities: any[] = [];
  categories: any[] = [];
  states: any[] = [];
  cities: any[] = [];
  yardiProperties = [];
  totalAmenities = 0;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private propertyService: PropertyService
  ) {
    this.propertyForm = this.fb.group({
      name: ['', Validators.required],
      latitude: [0, Validators.required],
      longitude: [0, Validators.required],
      address: ['', Validators.required],
      description: ['', Validators.required],
      yardi_property_id: [null, Validators.required],
      // property_category_id: [null, Validators.required],
      // amenities_id: [[], Validators.required],
      // country_id: [null, Validators.required],
      // state_id: [null, Validators.required],
      // user_id: [null, Validators.required],
      // city_id: [null, Validators.required],
      // property_min_price: [0, Validators.required],
      // property_max_price: [0, Validators.required],
      // property_min_deposit: [0, Validators.required],
      // property_max_deposit: [0, Validators.required],
      // property_units: ['', Validators.required],
      // status: [true, Validators.required],
    });
  }

  ngOnInit() {
    // this.getAllUsers();
    // this.getAllCountries();
    // this.loadAmenities();
    // this.getAllPropertyCategories();
    this.getAllYardiProperties();
    if (this.property) {
      this.propertyForm.patchValue({
        name: this.property.name,
        latitude: this.property.latitude,
        longitude: this.property.longitude,
        address: this.property.address,
        description: this.property.description,
        yardi_property_id: this.property.yardi_property_id?._id || this.property.yardi_property_id,
        // property_category_id: this.property.property_category_id?._id || this.property.property_category_id,
        // amenities_id: this.amenities?.map((a: any) => a._id) || [], // multiselect expects IDs
        // country_id: this.property.country_id?._id || this.property.country_id,
        // state_id: this.property.state_id?._id || this.property.state_id,
        // city_id: this.property.city_id?._id || this.property.city_id,
        // user_id: this.property.user_id?._id || this.property.user_id,
        // property_min_price: this.property.property_min_price,
        // property_max_price: this.property.property_max_price,
        // property_min_deposit: this.property.property_min_deposit,
        // property_max_deposit: this.property.property_max_deposit,
        // property_units: this.property.property_units,
        // status: this.property.status,
      });
    }
  }

  getAllYardiProperties() {
    this.propertyService.getAllYardiProperties().subscribe({
      next: (res) => {
        console.log('Yardi Properties:', res);
        this.yardiProperties = res.map((item: any) => item.payload);
        console.log('Mapped Yardi Properties:', this.yardiProperties);
      },
      error: (err) => console.error('Error fetching Yardi properties', err),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['property'] && this.property) {
      this.propertyForm.patchValue({
        amenities_id: this.property.amenities_id ?? []
      });
    }
  }

  loadAmenities(callback?: () => void): void {
    this.propertyService.getAllAmenities({
      search: '',
      limit: 500,
      page: 1
    }).subscribe((res: any) => {
      this.amenities = res.items;
      if (callback) callback();
    });
  }

  searchAmenities(event: any) {
    this.propertyService.getAllAmenities({
      search: event.query,
      limit: 500,
      page: 1
    }).subscribe((res: any) => {
      this.amenities = res.items;
    });
  }

  getAllUsers() {
    this.propertyService.getAllUsers(UserType.landlord).subscribe({
      next: (res) => (this.users = res),
      error: (err) => console.error('Error fetching users', err),
    });
  }

  getAllCountries() {
    this.propertyService.getAllCountries().subscribe({
      next: (res) => (this.countries = res),
      error: (err) => console.error('Error fetching countries', err),
    });
  }

  getAllAmenities() {
    this.propertyService.getAllAmenities().subscribe({
      next: (res: any) => {
        this.amenities = res.items.map((a: any) => ({
          label: a.name,
          value: a.id
        }));
      },
      error: (err) => console.error('Error fetching amenities', err),
    });
  }

  getAllPropertyCategories() {
    this.propertyService.getAllPropertyCategories().subscribe({
      next: (res) => (this.categories = res),
      error: (err) => console.error('Error fetching categories', err),
    });
  }
  onCountryChange(event: any) {
    const selectedCountryId = event.value;
    if (selectedCountryId != null) {
      this.propertyService.getStatesByCountry(selectedCountryId).subscribe(res => {
        this.states = res;
      });
    }

  }

  onStateChange(event: any) {
    const selectedStateId = event?.value;
    const selectedState = this.states.find(state => state._id === selectedStateId)?.name;
    if (selectedStateId != null) {
      this.propertyService.getCitiesByStates(selectedState).subscribe(res => {
        this.cities = res;
      });
    }

  }

  saveProperty() {
    if (this.propertyForm.valid) {
      const propertyData = this.propertyForm.value;
      console.log('propertyData', propertyData)
      console.log('property_id', this.property?._id)
      if (this.property?._id) { // Update
        // const formData = new FormData();
        // formData.append('propertyData', JSON.stringify(propertyData));
        // console.log('formData', formData.get('propertyData'));
        this.propertyService.updatePropertyBySuperAdmin(this.property._id, propertyData).subscribe({
          next: () => {
            console.log('updated')
            this.router.navigate(['/properties']);
          },
          error: (err) => {
            console.error('Error updating property:', err);
          },
        });
      } else { //Create
        this.propertyService.createProperty(propertyData).subscribe({
          next: () => {
            this.router.navigate(['/properties']);  // Redirect after success
          },
          error: (err) => {
            console.error('Error creating property:', err);
          },
        });
      }
    }
  }
}
